import { useContext } from "react";
import { OrganizationsContext } from "../../context/organizations/OrganizationsContext";

export const useOrganizations = () => useContext(OrganizationsContext);
